import { MfaLoginStage, MfaSetupStage } from '@oneview/constants/lookups';
import { UmaOption, UmaUserSerializer } from '@orbis-systems/orbis-api-clients/uma';
import { createAction } from '@reduxjs/toolkit';

export const loginTimeout = createAction('LoginTimeout');

export const setTermsOfUseSigned = createAction<boolean>('SetTermsOfUseSigned');

export const setMfaSetupStage = createAction<MfaSetupStage>('SetMfaSetupStage');

export const setMfaLoginStage = createAction<MfaLoginStage>('SetMfaLoginStage');

export const setAvailableMfaOptions = createAction<UmaOption[]>('SetAvailableMfaOptions');

export const setUmaUser = createAction<UmaUserSerializer>('SetUmaUser');

export const updateUmaUserMfaEnabled = createAction<boolean>('UpdateUmaUserMfaEnabled');

export const setEmailVerificationNeeded = createAction<boolean>('SetEmailVerificationNeeded');

export const setPhoneVerificationNeeded = createAction<boolean>('SetPhoneVerificationNeeded');
